<template>
  <section
    :style="{color:pageTextColor}"
    data-scroll-to="container-begin"
  >
    <div
      :class="['c-cbr-PageSection',$style.title]"
    ><p v-html="$t('error.something_went_wrong')"/>
    </div>
    <div  
      :class="[$style.btnDiv]">
      <obj-button
        :class="[$style.btn]"
        :is-disabled="false"
        :is-active="true"
        @click="createReturn()"
      >{{ $t('error.retry_again') }}</obj-button>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import VueScrollTo from 'vue-scrollto'
import ObjButton from '../components/ObjButton.vue'

export default {
  components: {
    ObjButton
  },

computed: {
    ...mapState('config', ['identifier']),
    ...mapGetters('config', [
      'pageTextColor',
      'buttonColor',
      'buttonTextColor',
      'parcelShopInfoBackgroundColor',
      'fieldTextColor'
    ])
  },

    mounted() {
      
    VueScrollTo.scrollTo('[data-scroll-to="container-begin"]', {
      offset: -100,
      easing: 'ease-out',
      duration: 0
    })
  },


  methods: {
    createReturn() {
      this.$router.push(`/m/` + this.identifier)

      window.setTimeout(() => {
        location.reload()
      }, 10)
    },
  },
}
</script>

<style module>


.btn {
  text-align: center;
  margin-top: 1.25rem;
  margin-bottom: 0px;
  margin-bottom: 15px;
}

.btnDiv {
  text-align: center;
  margin: 1.25rem;
  margin-left: 30px;
  margin-right: 30px;
}

.title {
  text-align: center;
  font-size: 1.65rem;
  padding-top: 0px;
  padding-bottom: 0px;
  margin:0px;
  @media (max-width: 599px) {
    font-size: 1.25rem;
  }
}



</style>



// WEBPACK FOOTER //
// client/views/ManualEntryFailure.vue